<h1 matDialogTitle
    translate>
    license_modal_activate_offline_title
</h1>

<mat-progress-bar [value]="progress"
                  mode="determinate"></mat-progress-bar>

<ng-container *ngLet="hasFile$ | async as hasFile">
    <mat-dialog-content>
        <ng-container *ngIf="hasFile === OfflineState.UNDETERMINED">
            <p translate>license_modal_activate_offline_valid_license</p>

            <mat-radio-group [(ngModel)]="hasValidLicense"
                             [attr.aria-label]="'license_modal_activate_offline_valid_license' | translate"
                             data-cy="valid-license-radio">
                <mat-radio-button [value]="OfflineState.NO"
                                  data-cy="valid-license-no">{{
                    'modal_action_no' | translate
                }}</mat-radio-button>
                <mat-radio-button [value]="OfflineState.YES"
                                  data-cy="valid-license-yes">{{
                    'modal_action_yes' | translate
                }}</mat-radio-button>
            </mat-radio-group>
        </ng-container>
        <ng-container *ngIf="hasFile === OfflineState.NO">
            <p translate>license_modal_activate_offline_generate_request</p>
            <form #form
                  [formGroup]="formGroup">
                <mat-form-field>
                    <input #installationID
                           [placeholder]="'license_modal_activate_offline_installation_id' | translate"
                           [readonly]="true"
                           [value]="context.data.installationId"
                           [formControlName]="LicenseFormControl.installationId"
                           matInput
                           required />
                    <span matSuffix>
                        <button [uiClipboard]="installationID"
                                [matTooltip]="'form_action_copy' | translate"
                                (clipboardSuccess)="clipboardCopied()"
                                mat-icon-button
                                type="button">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </span>
                </mat-form-field>
                <mat-form-field>
                    <input [placeholder]="'license_modal_activate_offline_license_key' | translate"
                           [formControlName]="LicenseFormControl.licenseKey"
                           matInput
                           required
                           data-cy="license-key-input" />
                </mat-form-field>
                <label class="mat-form-radio-label">
                    {{ 'license_modal_activate_offline_environment_designation' | translate }} *
                </label>
                <mat-radio-group [formControlName]="LicenseFormControl.environment"
                                 required>
                    <mat-radio-button value="Production"
                                      data-cy="environment-radio-production">
                        {{ 'license_modal_activate_offline_production' | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="NonProduction"
                                      data-cy="environment-radio-nonproduction">
                        {{ 'license_modal_activate_offline_nonproduction' | translate }}
                    </mat-radio-button>
                    <mat-radio-button value="Hybrid"
                                      data-cy="environment-radio-hybrid">
                        {{ 'license_modal_activate_offline_hybrid' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </form>
        </ng-container>
        <ng-container *ngIf="hasFile === OfflineState.GENERATE">
            <div class="numbered-list">
                <button mat-mini-fab
                        type="button">1</button>
                <div class="instruction-step">
                    <p class="instruction-text"
                       translate>
                        license_modal_activate_offline_download_request
                    </p>
                    <div class="layout-row">
                        <mat-form-field>
                            <input [value]="'activation_request.txt'"
                                   matInput
                                   readonly
                                   required
                                   data-cy="license-file-name-input" />
                        </mat-form-field>

                        <label #downloadButton>
                            <button (click)="generate()"
                                    mat-raised-button
                                    color="primary"
                                    type="button">
                                <mat-icon>file_download</mat-icon>
                                <span class="text-upper"
                                      translate>
                                    license_modal_activate_offline_download
                                </span>
                            </button>
                        </label>
                    </div>
                </div>
            </div>
            <div class="numbered-list">
                <button mat-mini-fab
                        type="button">2</button>
                <div class="instruction-step">
                    <p class="instruction-text">
                        {{ 'license_modal_activate_offline_directions_activate_url' | translate | translateCut: 0 }}
                        <a [href]="serviceUrl"
                           target="_blank">
                            {{ serviceUrl }}
                        </a>
                        {{ 'license_modal_activate_offline_directions_activate_url' | translate | translateCut: 1 }}
                    </p>
                </div>
            </div>
            <div class="numbered-list">
                <button mat-mini-fab
                        type="button">3</button>
                <div class="instruction-step">
                    <p class="instruction-text"
                       translate>
                        license_modal_activate_offline_step_3
                    </p>
                    <ng-template [ngTemplateOutlet]="uploadLicense"></ng-template>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="hasFile === OfflineState.YES">
            <ng-template [ngTemplateOutlet]="uploadLicense"></ng-template>
        </ng-container>

        <ng-template #uploadLicense>
            <div [fileBrowseRef]="browseTrigger"
                 [fileClearRef]="clearTrigger"
                 [multiple]="false"
                 (fileChange)="onFileChange($event)"
                 (fileClear)="onClear()"
                 uiDragAndDropFile
                 fileType=".txt"
                 class="license-overview-actions">
                <div class="layout-row">
                    <mat-form-field class="flex">
                        <input [value]="fileName"
                               [placeholder]="'license_modal_activate_offline_upload_placeholder' | translate"
                               matInput
                               readonly
                               required
                               data-cy="license-file-name-input" />
                    </mat-form-field>

                    <div #clearTrigger>
                        <button *ngIf="file"
                                mat-icon-button
                                class="ui-cancel-button"
                                type="button">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </div>

                    <label #browseTrigger>
                        <button mat-raised-button
                                color="primary"
                                class="ui-upload-button"
                                type="button">
                            <mat-icon>folder</mat-icon>
                            <span translate
                                  class="text-upper">
                                modal_action_browse
                            </span>
                        </button>
                    </label>
                </div>
            </div>
        </ng-template>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-dialog-close
                mat-button
                type="button">
            {{ 'modal_action_cancel' | translate }}
        </button>

        <button *ngIf="hasFile === OfflineState.UNDETERMINED"
                (click)="hasFile$.next(hasValidLicense)"
                mat-flat-button
                color="primary"
                data-cy="next-button"
                type="button">
            {{ 'modal_action_next' | translate }}
        </button>

        <button *ngIf="hasFile === OfflineState.NO"
                [disabled]="formGroup.invalid"
                (click)="hasFile$.next(OfflineState.GENERATE);"
                mat-flat-button
                color="primary"
                data-cy="generate-button"
                type="button">
            {{ 'modal_action_generate' | translate }}
        </button>

        <button *ngIf="[OfflineState.GENERATE, OfflineState.YES].includes(hasFile)"
                [disabled]="!file"
                (click)="onSubmit()"
                mat-flat-button
                color="primary"
                data-cy="activate-online-button"
                type="button">
            <ng-container *ngIf="!context.data.update; else update">
                {{ 'modal_action_activate' | translate }}
            </ng-container>
            <ng-template #update>
                {{ 'modal_action_update' | translate }}
            </ng-template>
        </button>
    </mat-dialog-actions>
</ng-container>
